import IconButton from '@/components/elements/IconButton';
import Typography from '@/components/elements/Typography';
import { useSidebar } from '@/store';
import { isSubRoute } from '@/utils';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useMemo, HTMLAttributes, ReactNode } from 'react';
import { ArrowLeft } from '../icons';
import BurgerMenu from '../icons/BurgerMenu';

export type MobileAppbarProps = {
  children?: ReactNode;
  page?: string;
  renderRightButton?: ReactNode;
} & HTMLAttributes<HTMLElement>;

/**
 * @component MobileAppbar
 */
function MobileAppbar({
  className,
  page,
  renderRightButton,
  ...rest
}: MobileAppbarProps) {
  const { setCollapse } = useSidebar();

  const router = useRouter();

  const handleBurgerMenuClick = () => {
    setCollapse(false);
  };

  const handleBackClick = () => {
    router.back();
  };

  const isSub = useMemo(() => isSubRoute(router.pathname), [router.pathname]);

  const classes = clsx(
    `fixed top-0 flex items-center bg-white z-50 px-6 md:px-8 w-full h-[85px] min-h-[85px]`,
    className,
  );
  return (
    <div className={classes} {...rest}>
      <div className="flex-1">
        {!isSub && (
          <IconButton onClick={handleBurgerMenuClick}>
            <BurgerMenu />
          </IconButton>
        )}

        {isSub && (
          <IconButton onClick={handleBackClick}>
            <ArrowLeft />
          </IconButton>
        )}
      </div>
      <Typography variant="h5" className="flex-1 text-center whitespace-nowrap">
        {page}
      </Typography>
      <div className="flex-1 flex items-center justify-end">
        {renderRightButton}
      </div>
    </div>
  );
}

export default MobileAppbar;
